// extracted by mini-css-extract-plugin
export default {"types_section":"styles-module__types_section___TGwJv","esg":"styles-module__esg___UMwx5","ir":"styles-module__ir___jzRKY","watchlists":"styles-module__watchlists___xjCx9"};